import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import renderNode, { Div } from '@doltech/ui/lib/figma/renderNode';
import { responsiveBreakPoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content;
  gap: 12px;
  justify-content: space-between;
  align-items: center;

  .header-title {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 12px;
    align-items: center;
  }
  .icon-wrapper {
    font-size: 24px;
    line-height: 0;
    @media ${responsiveBreakPoints['above-1024']} {
      font-size: 32px;
    }
  }
  &&& .ant-typography {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;

    @media ${responsiveBreakPoints['above-1024']} {
      font-size: 32px;
      line-height: 40px;
    }
  }
`;

export const TitleH2DailyLearning = ({
  icon = null,
  className = 'font-inter',
  children,
  renderRight = null,
  ...rest
}) => {
  const Icon = icon;
  return (
    <Main>
      <div className="header-title">
        {icon && (
          <div className="icon-wrapper">
            <Icon />
          </div>
        )}
        <Typography.Title
          variant="semi-bold/32"
          className={className}
          color="black100"
          level={2}
          {...rest}
        >
          {children}
        </Typography.Title>
      </div>
      {renderRight && renderNode(Div, renderRight, {})}
    </Main>
  );
};
